// The Quote `price` is the tax-included total; `taxAmount` is the tax within it.
// We headline the before-tax figure everywhere a quote price is shown because
// customers comparison-shop on the before-tax price.
export function priceBeforeTax(price: number, taxAmount: number): number {
  return price - taxAmount;
}
